//学生保险模块
export default[
    {
        path:'/HarbinBank/loan',
        component: resolve => require(['@/pages/studentInsure/HarbinBank.vue'], resolve),
        meta:{
        title:'哈尔滨银行贷款'
        }
    },
    {
        path:'/CDBBank/loan',
        component: resolve => require(['@/pages/studentInsure/CDBBank.vue'], resolve),
        meta:{
        title:'国开行银行贷款'
        }
    },
    {
        path:'/studentInsurance/loan',
        component: resolve => require(['@/pages/studentInsure/studentInsurance.vue'], resolve),
        meta:{
        title:'学生保险'
        }
    },
    {
        path: '/student/studentContingent',
        component: resolve => require(['@/pages/student/studentContingent.vue'], resolve),
        name:'studentContingent',
        meta: {
        title: '学生队伍管理'
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/modules/studentInsurance.js